import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import useMobileMenu from '../../hooks/useMobileMenu'
import loadable from '@loadable/component'

const ArticlesSubMenu = loadable(() => import('./ArticlesSubMenu'))

function MegaMenu({ desktop, open }) {
  const { close: closeMobileMenu } = useMobileMenu()

  function setClasses() {
    let classes = 'c-mega-menu'

    if (desktop) classes += ' c-mega-menu--desktop'
    if (open) classes += ' c-mega-menu--open'

    return classes
  }

  return (
    <div className={setClasses()} tabIndex="-1">
      <div className={desktop ? 'o-width-limiter o-width-limiter--full' : ''}>
        <h2 className="visually-hidden">Additional articles</h2>
        <div className="c-mega-menu__inner">
          <div className="o-grid">
            <div
              className="c-mega-menu__category c-mega-menu__category--1  o-grid__column"
              data-size="sm:24 lg:6"
            >
              <h3 className="c-mega-menu__heading">Food &amp; Eating</h3>
              {open && <ArticlesSubMenu articleType="food" />}
            </div>
            <div
              className="c-mega-menu__category c-mega-menu__category--2  o-grid__column"
              data-size="sm:24 lg:6"
            >
              <h3 className="c-mega-menu__heading">Fitness &amp; Exercise</h3>
              {open && <ArticlesSubMenu articleType="fitness" />}
            </div>
            <div
              className="c-mega-menu__category c-mega-menu__category--3  o-grid__column"
              data-size="sm:24 lg:6"
            >
              <h3 className="c-mega-menu__heading">About our features</h3>
              {open && <ArticlesSubMenu articleType="features" />}
            </div>
            <div
              className="c-mega-menu__category c-mega-menu__category--4  o-grid__column"
              data-size="sm:24 lg:6"
            >
              <h3 className="c-mega-menu__heading">Health education</h3>
              <div>
                {open && <ArticlesSubMenu articleType="health-education" />}
                <Link
                  className="c-mega-menu__read-more"
                  to="/health-education/"
                  onClick={closeMobileMenu}
                >
                  More articles
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

MegaMenu.propTypes = {
  desktop: PropTypes.bool,
  open: PropTypes.bool,
}

export default MegaMenu
